<template>
  <b-container>
    <b-form @submit.prevent="submitForm">
      <b-row class="mb-3">
        <b-col xs="12" sm="12" md="12" lg="6" xl="6">
          <b-form-group label="Provider" label-for="provider">
            <vue-multiselect
              v-model="form.provider"
              id="ajax"
              label="name"
              track-by="name"
              placeholder="Type to search"
              open-direction="bottom"
              :options="providers || []"
              :multiple="false"
              :searchable="true"
              :loading="isLoadingProviders"
              :internal-search="false"
              :clear-on-select="false"
              :close-on-select="false"
              :options-limit="300"
              :limit="3"
              :max-height="600"
              :show-no-results="true"
              :hide-selected="true"
              :selectLabel="''"
            >
            </vue-multiselect>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="6" xl="6">
          <b-form-group label="Price" label-for="price">
            <Money
              class="form-control text-center"
              v-model="form.price"
              v-bind="money"
            />
          </b-form-group>
        </b-col>

        <!-- date -->
        <b-col xs="12" sm="12" md="12" lg="6" xl="6">
          <b-form-group label="Date" label-for="date">
            <b-form-datepicker v-model="form.date"></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end">
        <b-button :disabled="isLoadingForm" type="submit" variant="primary"
          >Submit
          <!-- loader -->
          <b-spinner
            v-if="isLoadingForm"
            small
            class="ml-2"
            variant="light"
          ></b-spinner>
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import { GET_SUPPLIERS_LIST, POST_VEHICLE_PROVIDER_PRICE } from "./actions";
import { generalMixin } from "@/modules/mixin.js";
import { Money } from "v-money";
import { mapState } from "vuex";

export default {
  name: "ProviderPriceForm",
  mixins: [generalMixin],
  components: {
    Money,
  },
  props: {
    vehicleId: {
      type: Number,
      required: false,
    },
    refreshData: {
      type: Function,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
    providerItem: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      providers: (state) =>
        state.adminStore.vehiclesProviderPrice.providersList.data,
      isLoadingProviders: (state) =>
        state.adminStore.vehiclesProviderPrice.providersList.status ==
        "fetching",
    }),
  },
  data() {
    return {
      form: {
        provider: null,
        price: null,
        date: null,
      },
      isLoadingForm: false,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    };
  },
  methods: {
    submitForm() {
      this.isLoadingForm = true;
      const payload = {
        id: this.form.id ?? null,
        vehicleId: this.vehicleId ?? this.form.vehicleId,
        supplierId: this.form.provider.id,
        price: this.form.price,
        date: this.form.date,
      };
      this.$store
        .dispatch(POST_VEHICLE_PROVIDER_PRICE, payload)
        .then(() => {
          this.makeToast(
            "Success",
            "Provider price saved successfully",
            "success"
          );
          this.refreshData();
          this.hideModal();
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
        })
        .finally(() => {
          this.isLoadingForm = false;
        });
    },
    getProviders() {
      this.$store.dispatch(GET_SUPPLIERS_LIST).then(() => {
        if (this.providerItem) {
          this.formatForm();
        }
      });
    },

    formatForm() {
      this.form.provider = this.providers.find(
        (provider) => provider.id === this.providerItem.supplierId
      );
      this.form.price = this.providerItem.price;
      this.form.id = this.providerItem.id;
      this.form.date = this.providerItem.date;
      this.form.vehicleId = this.providerItem.vehicleId;
    },
  },
  mounted() {
    this.getProviders();
  },
};
</script>
